export interface IGeoPosState {
  current: IGeoPos;
  list: Array<IGeoPos>;
}

export interface IGeoPos {
  id: any;
  name?: {
    it?: string;
    sl?: string;
    en?: string;
  };
}

export const GEOPOS_STATE = {
  current: null,
  list: []
};

export class GeoPos implements IGeoPos {
  id: any;
  name?: {
    it?: string;
    sl?: string;
    en?: string;
  };

    constructor(obj: IGeoPos = {} as IGeoPos) {
        const {
          id= null,
          name= {},
        } = obj;

        this.id = id,
        this.name = name;
    }

    static from(obj): IGeoPos {
      return new GeoPos({
        id : obj.geographical_id,
        name : {
          it : obj.name_it,
          sl : obj.name_sl,
          en : obj.name_en
        }
      });
  }
  static fromArray(list) {
      if (!list || !(list instanceof Array)) {
          return [];
      }
      return list.map(GeoPos.from).filter(item => item != null);
  }

  static to(obj) {
    return {
      geographical_id : obj.id,
      name_it : obj.name.it,
      name_sl : obj.name.sl,
      name_en : obj.name.en
    };
  }
  static toArray(list) {
    if (!list || !(list instanceof Array)) {
        return [];
    }
    return list.map(GeoPos.to).filter(item => item != null);
  }
}
